import * as React from 'react'
import Avatar from 'components/Avatar'
import { FormGroup } from 'components/inputs'
import {
  CustomSelect,
  SingleItemSelectedDefault,
  useCustomSelectStateFromInfiniteScrollProvider,
} from 'components/inputs/CustomSelect'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import { observer } from 'mobx-react'
import OwnerSelectorViewModel from 'jobs/creation/OwnerSelectorViewModel'

interface CompactOwnerSelectorProps {
  vm: OwnerSelectorViewModel
}

export default observer(function CompactOwnerSelector({
  vm,
}: CompactOwnerSelectorProps) {
  const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
    scrollProvider: vm.scrollProvider,
    searchText: vm.searchText.value,
    onSearchTextChange: vm.triggerSearch,
    searchResults: vm.filteredMembers,
  })

  return (
    <FormGroup>
      <CustomSelect
        {...selectProps}
        placeholder="Select client"
        itemToString={(v) => String(v?.displayName)}
        disabled={vm.disabled}
        focus$={vm.step.becomeActive$}
        onFocus={vm.step.onBecameActive}
        value={vm.selectedOwner ?? undefined}
        onChange={vm.selectOwner}
        multi={false}
        data-test="compact-owner-selector"
        renderItem={(itemProps) => (
          <SingleItemSelectedDefault
            visual={
              <Avatar
                size={24}
                subject={{
                  displayName: itemProps.item.displayName,
                  avatar: itemProps.item.avatar,
                }}
              />
            }
            {...itemProps}
          />
        )}
        renderSearchItem={({ item, itemToString, ...itemProps }) => (
          <SearchResultItem
            {...itemProps}
            visual={
              <Avatar
                size={24}
                subject={{
                  avatar: item.avatar,
                  displayName: item.displayName,
                }}
              />
            }
          >
            {item.displayName}
          </SearchResultItem>
        )}
      />
    </FormGroup>
  )
})
